__turbopack_context__.v({
  "className": "spacegrotesk_e80d98eb-module__EorwZq__className",
  "variable": "spacegrotesk_e80d98eb-module__EorwZq__variable",
});
